/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_PlayedInputs */

const en_mobile_played = /** @type {(inputs: Mobile_PlayedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Played`)
};

const es_mobile_played = /** @type {(inputs: Mobile_PlayedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducido`)
};

/**
* | output |
* | --- |
* | "Played" |
*
* @param {Mobile_PlayedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_played = /** @type {((inputs?: Mobile_PlayedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_PlayedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_played(inputs)
	return en_mobile_played(inputs)
});